import { AccountOutlineIcon } from './AccountOutlineIcon';

/**
 * author: Google
 * id 79ECAAC6-71DC-406C-A9B7-57C5F0BAA9E0
 * name account-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-outline.svg
 * tags
 * - Account / User 
 */
export const PermIdentityIcon = AccountOutlineIcon;
export default PermIdentityIcon